module.exports = __webpack_public_path__ + "img/icon_map_61_on_100.02e82431.png";